import http from './http-common';
import storage from '../factory/StorageFactory';
 
//State Api
const postState = (data) => {
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank " + storage.getToken()
        }
    }
      
    return http.post('/api/v1/State', data,headerParams);
}

const getStateValidate = (stateId,param) => {
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank " + storage.getToken()
        }
    }
      
   let url = '/api/v1/State/validate/'+stateId;
   if(param){
       url = url+'/'+param
   }
   return http.get(url,headerParams);
}

const getStateCheck = (stateId) => {
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank "+ storage.getToken()
        }
    }
      
    let url = '/api/v1/State/check/'+stateId;
    return http.get(url,headerParams);
}


export default {
    postState,
    getStateValidate,
    getStateCheck
}

